import { getCampaignsListRequest, getCampaignSpentBudgetRequest } from "@common";
import { FETCH_STATE_INITIAL } from "rd-redux-http";
import { CampaignInfo } from "../api";

export interface CampaignListState {
    campaigns: typeof getCampaignsListRequest.types.reduxState;
    sortedCampaigns: CampaignInfo[];
    selectedCampaignId: string;
    selectedPurchasedCampaignName: string;
    campaignSpentBudget: {
        [campaignId: string]: typeof getCampaignSpentBudgetRequest.types.reduxState;
    };
}

export const initialCampaignListState: CampaignListState = {
    campaigns: { fetchState: FETCH_STATE_INITIAL },
    sortedCampaigns: [],
    selectedCampaignId: undefined,
    campaignSpentBudget: {},
    selectedPurchasedCampaignName: undefined
};
